var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddFavouriteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_1747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 4.75325L8.64683 6.27992L8.96016 7.01992L9.76016 7.08659L11.4068 7.22659L10.1535 8.31325L9.54683 8.83992L9.72683 9.62659L10.1002 11.2333L8.68683 10.3799L8.00016 9.95325L7.3135 10.3666L5.90016 11.2199L6.2735 9.61325L6.4535 8.82659L5.84683 8.29992L4.5935 7.21325L6.24016 7.07325L7.04016 7.00659L7.3535 6.26659L8.00016 4.75325ZM8.00016 1.33325L6.12683 5.75325L1.3335 6.15992L4.9735 9.31325L3.88016 13.9999L8.00016 11.5133L12.1202 13.9999L11.0268 9.31325L14.6668 6.15992L9.8735 5.75325L8.00016 1.33325Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_1747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFavouriteIcon);
export default __webpack_public_path__ + "static/media/add-favourite-icon.7a6757d474725ec76f747b2887b89cbc.svg";
export { ForwardRef as ReactComponent };